const angular = require('angular');

const DeliveryOptionsService = require('./delivery-options.service');

angular.module('wowApp.shop')
    .service('DeliveryOptionsService', DeliveryOptionsService);



// WEBPACK FOOTER //
// ./src/order/deliveryoptions/index.js